function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'charcoal': 'rgb(54, 69, 79)','rose': 'rgb(255, 0, 102)','ocean': 'rgb(77, 136, 255)','cobalt': 'rgb(1, 87, 155)','dusk': 'rgb(148, 148, 184)','stone': 'rgb(209, 224, 224)','jade': 'rgb(57, 172, 57)','blush': 'rgb(153, 0, 61)','loam': 'rgb(96, 64, 32)','violet': 'rgb(179, 102, 255)','forest': 'rgb(34, 49, 29)','sun': 'rgb(255, 191, 0)','orange': 'rgb(253, 115, 12)','clay': 'rgb(218, 146, 92)','moss': 'rgb(110, 148, 103)','cream': 'rgb(255, 250, 244)','navy': 'rgb(18, 22, 57)','silver': 'rgb(224, 224, 224)','graphite': 'rgb(92, 92, 92)','black-flat-brim': 'rgb(1, 1, 1)','olive-flat-brim': 'rgb(85, 100, 70)','spruce': 'rgb(21, 63, 58)','espresso': 'rgb(76, 50, 37)','emerald': 'rgb(5, 61, 20)','sky': 'rgb(166, 217, 227)','midnight': 'rgb(10, 9, 38)','caramel': 'rgb(153, 75, 2)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
